import { ThemeProvider } from '@mui/material';
import { Route, Routes } from 'react-router-dom';
import { theme } from '../theme';
import CompoundPage from './compound/CompoundPage';
import SevenKnightsCouponPage from './coupon/seven-knights/SevenKnightsCouponPage';
import RouteChangeTracker from './RouteChangeTracker';
import { Layout } from './Layout/Layout';
import { HomePage } from './home/HomePage';
import { PrivacyPolicyPage } from './privacy-policy/PrivacyPolicyPage';
import BlogPostPage from './blog/BlogPostPage';
import BlogListPage from './blog/BlogListPage';
import { AboutPage } from './about/AboutPage';
import LottoPage from './lotto/LottoPage';
import LottoTaxCalculatorPage from './lotto/tax-calculator/LottoTaxCalculatorPage';
import RetirementPage from './retirement/RetirementPage';


function App() {
  return (
    <ThemeProvider theme={theme}>
      <RouteChangeTracker />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/compound" element={<CompoundPage />} />
          <Route path="/retirement" element={<RetirementPage />} />
          <Route
            path="/coupon/seven-knights"
            element={<SevenKnightsCouponPage />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:postId" element={<BlogPostPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/lotto" element={<LottoPage />} />
          <Route path="/lotto/tax-calculator" element={<LottoTaxCalculatorPage />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App;
